import { render } from "./product-banner-two.vue?vue&type=template&id=1871d3a3&scoped=true"
import script from "./product-banner-two.vue?vue&type=script&lang=js"
export * from "./product-banner-two.vue?vue&type=script&lang=js"

import "./product-banner-two.vue?vue&type=style&index=0&id=1871d3a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1871d3a3"]])

export default __exports__